import React from 'react';
import PropTypes from 'prop-types';
import { graphql } from 'gatsby';
import { Container } from '@pella/sash-framework';
import { Layout, SEO, Breadcrumbs } from '../../components';
import BranchLinks from '../../components/template/branch-locations/branch-links';

const BranchLocations = (props) => {
	const pageData = props.data.contentstackLocationsByState;
	const branchData = props.data.branchData?.nodes;

	return (
		<Layout
			id='template-BranchLocations'
			pageTitle={pageData.seo?.title}
		>
			{pageData.breadcrumbs && (
				<Breadcrumbs
					data={pageData.breadcrumbs}
					currentUrl={pageData.url}
				/>
			)}

			<Container className='mb-6 md:mb-8 xl:mb-12'>
				<h1 className='mb-5 font-bold'>{pageData.state?.state_name || pageData.state?.province}</h1>

				{branchData?.[0] &&
					branchData.map((branch, index) => (
						<BranchLinks
							key={index}
							branch={branch}
							className={index > 0 ? 'mt-6' : null}
						/>
					))}
			</Container>
		</Layout>
	);
};

BranchLocations.propTypes = {
	data: PropTypes.object,
	location: PropTypes.object,
};

export default BranchLocations;

// eslint-disable-next-line react/prop-types -- gatsby component
export const Head = ({ data }) => <SEO {...data.contentstackLocationsByState.seo} />;

export const query = graphql`
	query ($uid: String!, $state: String, $province: String) {
		contentstackLocationsByState(id: { eq: $uid }) {
			url
			breadcrumbs {
				active_page
				back_pages {
					...CTA
				}
			}
			state {
				state_name
				abbreviation
				province
			}
			seo {
				...SEO
			}
		}

		branchData: allContentstackBranchData(sort: { formal_name: ASC }, filter: { state: { state_name: { eq: $state }, province: { eq: $province } } }) {
			nodes {
				...BranchData
			}
		}
	}
`;
